import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';
import { Moment } from 'moment';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

export const yearFormat = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    yearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    yearA11yLabel: 'YYYY',
  },
};

@Component({
  selector: 'app-year',
  templateUrl: './year.component.html',
  styleUrls: ['./year.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YearComponent),
      multi: true,
    },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: yearFormat },
  ],
})
export class YearComponent implements ControlValueAccessor {
  form: FormGroup;
  private _value: any;

  onChanged: any = () => {};
  onTouched: any = () => {};

  maxManufactureYear = new Date(new Date().getFullYear() + 1, 11 , 31);
  destroy$ = new Subject();

  get value() {
    return this._value;
  }

  set value(value: any) {
    this._value = value;
    this.onChanged(this._value);
    this.onTouched();
  }

  constructor() {
    this.form = new FormGroup({
      year: new FormControl(null, [Validators.required]),
    });
  }

  ngOnInit(): void {}


  ngOnDestroy(): void {
    this.destroy$.complete();
  }

  yearSelected(normalizedYear: Moment, datepicker: MatDatepicker<Moment>) {
    let ctrlValue = moment();
    ctrlValue.year(normalizedYear.year());
    const years = new Array(5).fill(1).map((_, i) => ctrlValue.clone().subtract(i, 'y').year().toString());
    const selectedYear: string = years[0];
    this.form.get('year').setValue(selectedYear);
    datepicker.close();
  }

  writeValue(value: any): void {
    this.value = value;
    this.form.get('year').setValue(value);
  }


  registerOnChange(onChange: any): void {
    this.form.get('year').valueChanges.pipe(takeUntil(this.destroy$)).subscribe(onChange);
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }
}
